import { usePageContext } from "../hooks/usePageContext"

export function Link({ to, className, children }) {
    const pageContext = usePageContext()
    const newClassName = [className, pageContext.urlPathname === to && 'is-active'].filter(Boolean).join(' ')
    const props = { className: newClassName, children, href: to }
    return <a {...props} />
}